<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 1024 1024" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <path d="M675.2 968.4H348.8c-73.9 0-143.4-28.8-195.7-81.1C100.8 835 72 765.5 72 691.6V332.4c0-73.9 28.8-143.4 81.1-195.7 52.3-52.3 121.8-81.1 195.7-81.1h326.4c73.9 0 143.4 28.8 195.7 81.1C923.2 189 952 258.5 952 332.4v359.2c0 73.9-28.8 143.4-81.1 195.7-52.3 52.3-121.8 81.1-195.7 81.1zM348.8 109.1c-123.1 0-223.3 100.2-223.3 223.3v359.2c0 123.1 100.2 223.3 223.3 223.3h326.4c123.1 0 223.3-100.2 223.3-223.3V332.4c0-123.1-100.2-223.3-223.3-223.3H348.8z" data-follow-fill="#231815" :fill="_fill" />
      <path d="M722 722.9H302c-15.7 0-28.5-12.8-28.5-28.5s12.8-28.5 28.5-28.5h420c15.7 0 28.5 12.8 28.5 28.5s-12.8 28.5-28.5 28.5zm0-182.4H302c-15.7 0-28.5-12.8-28.5-28.5s12.8-28.5 28.5-28.5h420c15.7 0 28.5 12.8 28.5 28.5s-12.8 28.5-28.5 28.5zM455.5 358.1H299.7c-14.4 0-26.1-12.8-26.1-28.5s11.7-28.5 26.1-28.5h155.9c14.4 0 26.1 12.8 26.1 28.5s-11.7 28.5-26.2 28.5zm269.6 0H573.7c-14 0-25.4-12.8-25.4-28.5s11.4-28.5 25.4-28.5h151.4c14 0 25.4 12.8 25.4 28.5s-11.4 28.5-25.4 28.5z" data-follow-fill="#231815" :fill="_fill" />
    </g>
  </svg>
</template>
<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1.4em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
